import styled, { css } from 'styled-components';
import { darkMode, darkPalette } from '../../core/theme/darkTheme';

export const LogoWrapper = styled.div<{ $withFlags?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: ${({ $withFlags }) => ($withFlags ? 'space-between' : 'center')};
  text-align: center;
  padding: ${({ $withFlags }) => ($withFlags ? '6px 16px' : '11px 0')};
  position: relative;
  width: 100vw;
  background-color: #fff;
  z-index: 1000;

  &::after {
    content: '';
    display: block;
    width: 100vw;
    height: 1px;
    background: #d9ebf1;
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
  }

  ${darkMode(css`
    background-color: ${darkPalette.background};

    &::after {
      background: ${darkPalette.divider};
    }
  `)}
`;

export const Logo = styled.div`
  width: 24px;
  height: 24px;
  background: url(${'/images/header-logo.svg'}) center / contain no-repeat;
  ${({ theme }) => css`
    margin-${theme.isRtl ? 'right' : 'left'}: 8px;
  `}
`;

export const Text = styled.div`
  font-weight: 500;
  font-size: 18px;
  line-height: 19px;
  color: ${({ theme }) => theme?.colors?.text};
`;

export const LogoCluster = styled.div`
  display: flex;
  align-items: center;
`;

export const FlagChip = styled.button`
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px;
  border: none;
  border-radius: 12px;
  background: transparent;
  cursor: pointer;

  &:hover {
    background: #f4f4f4;
  }

  ${darkMode(css`
    &:hover {
      background: ${darkPalette.surface};
    }
  `)}
`;

export const FlagChipImg = styled.img`
  width: 28px;
  height: 20px;
  object-fit: cover;
`;

export const FlagCode = styled.span`
  font-size: 16px;
  line-height: 23px;
  padding-top: 2px;
  color: ${({ theme }) => theme?.colors?.text};
`;
